import type { EncoderConfig } from '@playcastdotio/CoreTypes';
import type { PlaycastMessage, PlaycastMessageEncoderSetConfig, PlaycastMessageEncoderToggle, PlaycastMessageSource } from '../types';
import { formatMessage } from './_util/formatMessage';

const target = 'encoder';

export const setEncoderConfig = (
  hostId: string,
  config: EncoderConfig,
  userAuth?: string,
): PlaycastMessage<PlaycastMessageEncoderSetConfig> => {
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageEncoderSetConfig = {
    target,
    action: 'setConfig',
    isReply: false,
    message: config,
  };

  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageEncoderSetConfig>;
};

export const toggleEncoder = (hostId: string, userAuth?: string): PlaycastMessage<PlaycastMessageEncoderToggle> => {
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageEncoderToggle = {
    target,
    action: 'toggle',
    isReply: false,
    message: {},
  };

  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageEncoderToggle>;
};
